module.exports = __webpack_public_path__ + "static/img/A-TFapple1.ac639b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-TFapple1.png
// module id = 14dD
// module chunks = 4